import { useEffect, useState } from 'react';
import axios from 'axios';
import { ValidateOtpRequest, ApiResponse } from 'vopay';
import vopayApi from '../../services/api.config';

const hook = vopayApi.withApiHook(({ api }) => {
  return function useValidate() {
    const source = axios.CancelToken.source();
    const [pending, setPending] = useState(false);

    const validateOtp = (requestParams: ValidateOtpRequest): Promise<ApiResponse> => {
      try {
        setPending(true);
        return api.postValidateOtp(requestParams, source);
      } finally {
        setPending(false);
      }
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      pending,
      validateOtp,
    };
  };
});

export default hook({});
